import { useThemeColor } from '@hooks/useThemeColor'
import { ActivityIndicator, Dimensions } from 'react-native'
import { View } from 'tamagui'

export function LoadingScreen() {
  const height = Dimensions.get('window').height
  const background = useThemeColor('bg-page')
  const spinner = useThemeColor('spinner')

  return (
    <View style={{ backgroundColor: background, flex: 1 }}>
      <ActivityIndicator size="large" color={spinner} style={{ height }} />
    </View>
  )
}
